module.exports = "https://cdn.redage.net/src/views/donate/main/elements/shop/img/p_1.svg";